import React from 'react';
import { 
  UserCircle, Settings, FileText, HelpCircle, LogOut, ChevronDown 
} from 'lucide-react';

const UserProfileMenu = ({ user, userMenuOpen, setUserMenuOpen, handleLogout, userMenuRef }) => {
  // Get user initials for avatar
  const getInitials = () => {
    if (!user) return '';
    
    if (user.displayName) {
      const names = user.displayName.split(' ');
      if (names.length >= 2) {
        return `${names[0][0]}${names[1][0]}`.toUpperCase();
      }
      return user.displayName[0].toUpperCase();
    }
    
    // If no display name, use first character of email
    return user.email[0].toUpperCase();
  };
  
  return (
    <div 
      ref={userMenuRef}
      className="relative"
    >
      <div 
        className="flex items-center space-x-2 cursor-pointer p-2 rounded hover:bg-gray-100"
        onClick={() => setUserMenuOpen(!userMenuOpen)}
      >
        <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold">
          {getInitials()}
        </div>
        <span className="font-medium">
          {user?.displayName || user?.email?.split('@')[0] || 'User'}
        </span>
        <ChevronDown size={16} />
      </div>

      {userMenuOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg py-2 z-10 border border-gray-200">
          <div className="px-4 py-3 border-b border-gray-200">
            <p className="text-sm font-medium text-gray-700">
              {user?.displayName || user?.email?.split('@')[0] || 'User'}
            </p>
            <p className="text-xs text-gray-500 truncate">{user?.email}</p>
          </div>
          
          <div className="py-1">
            <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              <UserCircle size={16} className="mr-3 text-gray-500" />
              <span>My Profile</span>
            </button>
            <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              <Settings size={16} className="mr-3 text-gray-500" />
              <span>Settings</span>
            </button>
            <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              <FileText size={16} className="mr-3 text-gray-500" />
              <span>My Documents</span>
            </button>
            <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              <HelpCircle size={16} className="mr-3 text-gray-500" />
              <span>Help Center</span>
            </button>
          </div>
          
          <div className="py-1 border-t border-gray-200">
            <button 
              className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
              onClick={handleLogout}
            >
              <LogOut size={16} className="mr-3" />
              <span>Sign out</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfileMenu; 